import { Flex } from "antd";
import Breadcrumb, { type TBreadcrumb } from "../../../components/Breadcrumb";
import Icon2 from "../_icons/brush-pin-icon.svg";
import Icon1 from "../_icons/person-icon.svg";

type Props = {
  title: string;
  breadcrumb: TBreadcrumb[];
};

export default function Hero({ title, breadcrumb }: Props) {
  return (
    <Flex
      justify="center"
      align="center"
      className="bg-gradient-to-l from-teal-700 to-gray-800 h-64 relative" // Added relative here
    >
      {/* Background decorative images - now positioned relative to the full hero */}
      <img
        className="absolute top-0 left-12 md:left-20 lg:left-52 w-20 md:w-28"
        src={Icon1}
        alt=""
      />
      <img
        className="absolute bottom-0 right-12  lg:right-5 w-20 md:w-28"
        src={Icon2}
        alt=""
      />

      <div className="container relative z-10 text-center">
        {" "}
        {/* z-10 to stay on top */}
        <h3 className="text-white text-5xl font-semibold mb-4">{title}</h3>
        <Breadcrumb breadcrumb={breadcrumb} />
      </div>
    </Flex>
  );
}
